import React from 'react';
import CardButton from '../CardButton/CardButton';
import './StarOfTheYearSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {star_of_year, view_overview} from '../../../../../cosmosTracking/cosmosEvents';
import Lottie from "react-lottie";
import {directDeepLink, SOURCE_HOME} from "../../../util";
import TaskCardMini from '../../OverviewInt/task-card-mini/taskCardMini';

function StarOfTheYearSlide({data}) {
    let location = new URL(window.location.href);
    let token = location.searchParams.get('token');
    let url = `https://campaigns.classplus.co/tutor/details/star?token=${token}`

    let deepLink = {
        "screen": "UTIL_WEBVIEW",
        "paramOne": url,
        "paramTwo": "",
        "paramTracking": "star_of_year",
        "paramThree": "",
        "paramSource": ""
    }
    return (
        <div className="slideCard slideCardYear">
            {/* <div className="cardHeader">
                <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-slide-home-header-title.png" alt="title"/>
            </div> */}
            <div className="cardBody">
                <img className="home-top-img"
                     src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-year-titlle.png" alt="signature"/>
                <TaskCardMini cards={data}/>
                {/* <div className="start-of-the-year">
                    <img className="year-of-img" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/new-year-sale-stars-img.png" alt=""/>
                    <div className="year-of-ribbon"
                         onClick={()=>{
                             directDeepLink(deepLink, SOURCE_HOME);
                         }
                    }
                         eventCallback={() => {
                             cosmosTrackService(star_of_year)
                         }}>
                        <h4>View Top Stars</h4> <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-star-box.png" height={16} alt=""/>
                    </div> */}
                {/* </div>
                <h3>Tutors with maximum points <span>will get a chance to become </span> 'Stars Of The Year'</h3> */}
            </div>
        </div>
    );
}

export default StarOfTheYearSlide;
